import { useEffect } from 'react';
import type { ZendeskSipCallStepComponent } from 'api/types';
import { useAppDispatch } from 'hooks';
import { setSipCallStatesByKey } from 'reducers/workflows';

interface SIPCallStepProps {
  isLastStep: boolean;
  setStepSent: (query?: string) => void;
  stepIndex: number;
  widgetComponent: ZendeskSipCallStepComponent;
}

export const ZendeskSipCallStep = ({
  setStepSent,
  widgetComponent,
}: SIPCallStepProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (widgetComponent.isSent) {
      return;
    }

    // Store the SIP call data in Redux state
    // Get component fields based on the component type
    const componentFields = widgetComponent.component_fields;
    const { room_url, sip_uri, token } = componentFields;

    dispatch(
      setSipCallStatesByKey({
        isVisible: true,
        readyToCall: true,
        roomUrl: room_url || '',
        sipUri: sip_uri || '',
        token: token || '',
      }),
    );

    // Mark the step as sent since we've processed the data
    setStepSent();
  }, [dispatch, setStepSent, widgetComponent]);

  // This component renders nothing - the UI is handled by the global ZendeskSipCallDrawer
  return null;
};
